// extracted by mini-css-extract-plugin
export var badges = "profile-recent-badges-module--badges---MNK9";
export var text = "profile-recent-badges-module--text--y+Isk";
export var textContainer = "profile-recent-badges-module--textContainer--IfNbx";
export var title = "profile-recent-badges-module--title--PzF6O";
export var viewAll = "profile-recent-badges-module--viewAll--7TD8A";